module.exports = "/_next/static/images/King-4cab3fda4419982f6585575c570f8122.png";